import { Capacitor } from "@capacitor/core";
import { SafeArea } from "@capacitor-community/safe-area";
import { useEffect } from "react";

export function useSafeArea() {
  const isNativePlatform = Capacitor.isNativePlatform();
  const isAvailable = Capacitor.isPluginAvailable("SafeArea");

  useEffect(() => {
    if (isNativePlatform && isAvailable) {
      SafeArea.enable({ config: {} });
    }
  }, []);
}
